<template lang="pug">
  .note-item
    v-card.elevation-0.border-bottom(style="border-radius:0px")
      v-row(align="center" no-gutters)
        v-col.shrink.pl-3.py-3
          v-layout.handle(:class="{ 'drag-active': drag }")
            ArrowsSortIcon.my-auto(size="22" :style="{ 'color': $vuetify.theme.themes[$theme].primary500 }")
        v-col.pa-3
          .p1.basic800--text {{ note.name }}
          .c1.basic600--text.mt-1 {{ getFormatDisplay(note.format) }}
        v-col.shrink.pr-1
          div.d-flex.align-center
            v-menu(bottom :offset-x='false' :offset-y='true')
              template(v-slot:activator="{ on, attrs }")
                v-btn(icon v-on="on" color="transparent")
                  eva-icon(name="more-vertical-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].primary500" style="margin: 3px 1px 0 0")
              v-list.pa-0
                v-list-item.border-bottom(@click="clickEdit")
                  v-list-item-content
                    v-list-item-title.s2.basic800--text {{ $t('edit_note') }}
                v-list-item.border-bottom(@click="clickRemove")
                  v-list-item-content
                    v-list-item-title.s2.basic800--text {{ $t('remove_from_product') }}
    v-divider.basic300

    .modals
      add-product-notes(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :parentNote.sync="note" :company="company")
      y-dialog(v-model='openDeleteDialog', max-width='290' persistent)
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('remove_from_product') }}
          v-card-text.p2.primary500--text.px-4
            | {{ $t('remove_from_product_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white' text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn(color='danger500' depressed dark @click='startRemove' :loading="isLoading")
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex'
import AddProductNotes from '@/components/productnotes/dialogs/AddProductNotes.vue'

export default {
  name: 'ProductNoteItem',
  props: ['parentNote', 'product', 'drag'],
  components: { AddProductNotes },
  data: () => ({
    showAddProductDialog: false,
    openDeleteDialog: false,
    isLoading: false
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    note: {
      get() {
        return this.parentNote
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    }
  },
  watch: {
    'note.enabled' (val) {
      this.updateNoteStatus(val)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getFormatDisplay (format) {
      if (format == 'long_text') {
        return 'Long text'
      } else if (format == 'short_text') {
        return 'Short text'
      } else if (format == 'numbers') {
        return 'Numbers'
      }
      return format
    },
    clickEdit () {
      this.showAddProductDialog = true
    },
    clickRemove () {
      this.openDeleteDialog = true
    },
    startRemove() {
      this.isLoading = true
      this.axios.delete(`/product_notes/${this.note.id}/products/${this.product.id}`)
        .then(() => {
          this.$emit('deleted', this.note)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateNoteStatus (val) {
      this.$axios.patch(`/product_notes/${this.note.id}/`, { enabled: val })
        .then(() => {
          this.showMessage(['success', `Note ${val ? 'enabled' : 'disabled'}`])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.drag-active { cursor: grabbing; }
</style>

<i18n>
{
  "en": {
    "edit_note": "Edit note",
    "remove_from_product": "Remove from product",
    "remove_from_product_confirmation": "Are you sure you want to remove this note from this product?"
  },
  "id": {
    "edit_note": "Edit nota",
    "remove_from_product": "Hapus dari produk",
    "remove_from_product_confirmation": "Yakin ingin hapus not dari produk ini?"
  }
}
</i18n>